module.exports = __webpack_public_path__ + "img/triangles.8abf145a.jpg";